import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FlexItem from "@insite/content-library/Widgets/Brand/FlexItem";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { IconProps } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import MGBWSearchIcon from "@tSurya/Icons/MGBWSearchIcon";
import TradeAccountIcon from "@tSurya/Icons/TradeAccountIcon";
import { useMobileSearch } from "@tSurya/Overrides/Pages/Header";
import { isThemeActive, getActiveThemeId, THEME_IDS } from "@tSurya/theme/themeHelper";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

import { COMMON } from "@tSurya/theme/design";

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface HeaderContainerStyle {
    headerContainer?: InjectableCss;
    headerSection?: InjectableCss;
    borderBottom?: InjectableCss;
    signInborderBottom?: InjectableCss;
    logoSearchContainer?: InjectableCss;
    logo?: InjectableCss;
    search?: InjectableCss;
    newBrandLogo?: InjectableCss;
    openTrade?: InjectableCss;
    myAccount?: InjectableCss;
    signInAccount?: InjectableCss;
    mainNavigation?: InjectableCss;
    cart?: InjectableCss;
    signIn?: HiddenProps;
    mobileSearchBarToggle?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchButtonIcon?: IconProps;
}

export const headerContainerStyle: HeaderContainerStyle = {
    headerContainer: {
        css: css`
            background: #ffffff;
        `,
    },

    headerSection: {
        css: css`
            @media (min-width: 992px) and (max-width: 1166px) {
                display: flex;
                align-items: center;
                justify-content: space-between;
                max-width: calc(100% - 40px);
                margin: 12px auto;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            max-width: calc(100% - 40px);
                            margin: 0 auto;
                            position: relative;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            ${isThemeActive(THEME_IDS.MGBW) ? `
                @media (max-width: 1166px) {
                    padding: 14px 16px;
                    border-bottom: 1px solid #E0E0E0;
                    max-width: 100%;
                    margin: 0;
                    position: relative;
                }
                @media (min-width: 1167px) {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding-top: 24px;
                    gap: 0;
                }
            ` : ''}
        `,
    },
    borderBottom: {
        css: css`
            border-bottom: 1px solid #e0e0e0;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    null,
                    null,
                ]);
            }}
            @media (min-width: 992px) and (max-width: 1166px) {
                border-bottom: none !important;
                width: 100% !important;
                order: 2 !important;
            }
            ${isThemeActive(THEME_IDS.MGBW) ? `
                @media (max-width: 1166px) {
                    border-bottom: none;
                    width: auto;
                }
                @media (min-width: 1167px) {
                    width: 100%;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 16px;
                }
            ` : ''}
        `,
    },
    signInborderBottom: {
        css: css`
            border-bottom: 1px solid #e0e0e0;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    null,
                    null,
                ]);
            }}

            @media (min-width: 992px) and (max-width: 1166px) {
                border-bottom: none !important;
                width: 100% !important;
                order: 2 !important;
            }
            ${isThemeActive(THEME_IDS.MGBW) ? `
                @media (max-width: 1166px) {
                    border-bottom: none;
                    width: auto;
                }
                @media (min-width: 1167px) {
                    width: 100%;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 16px;
                }
            ` : ''}
        `,
    },
    logoSearchContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            max-width: ${COMMON.width.content}px;
            margin: 0 auto;
            padding: ${isThemeActive(THEME_IDS.GLOBAL_VIEWS) ? '16px 0' : isThemeActive(THEME_IDS.MGBW) ? '0 40px' : '29px 0'};
            max-height: ${isThemeActive(THEME_IDS.MGBW) ? 'none' : '80px'};
            ${isThemeActive(THEME_IDS.MGBW) ? `
                @media (min-width: 768px) and (min-width: 1167px) {
                    position: relative;
                }
                @media (max-width: 1166px) {
                    justify-content: flex-end;
                    gap: 16px;
                    padding: 0;
                    max-width: none;
                }
                @media (min-width: 1167px) {
                    gap: 24px;
                    width: 100%;
                    min-height: 46px;
                    max-width: none;
                    margin: 0;
                }
            ` : ''}

            @media (min-width: 992px) and (max-width: 1166px) {
                max-width: 100% !important;
                padding: 0px !important;
                margin: 0 !important;
            }

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0px;
                            align-items: center;
                            justify-content: flex-end;
                            padding: ${isThemeActive(THEME_IDS.GLOBAL_VIEWS) ? '16px 0' : isThemeActive(THEME_IDS.MGBW) ? '0' : '20px 0'};
                            margin: 0 auto;
                        `,
                        null,
                        null,
                        css`
                            padding: ${isThemeActive(THEME_IDS.MGBW) ? '0 40px' : isThemeActive(THEME_IDS.GLOBAL_VIEWS) ? '16px' : '20px 16px'};
                            align-items: center;
                        `,
                        css`
                            padding: ${isThemeActive(THEME_IDS.MGBW) ? '0 40px' : isThemeActive(THEME_IDS.GLOBAL_VIEWS) ? '24px 0 16px' : '29px 0'};
                        `,
                    ], "min"
                );
            }}
        `,
    },
    mainNavigation: {
        css: css`
            max-width: ${COMMON.width.content}px;
            max-height: unset;
            margin: 0 auto;
            padding: 0;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            order: 1;
                            margin: 0;
                            max-height: ${isThemeActive(THEME_IDS.GLOBAL_VIEWS) ? '20px' : '42px'};
                        `,
                        null,
                        null,
                        css`
                            padding: 0;
                        `,
                        css`
                            padding: 0;
                        `,
                    ]
                );
            }}
            @media (min-width: 992px) and (max-width: 1166px) {
                order: 1 !important;
                margin: 0 !important;
            }
            ${isThemeActive(THEME_IDS.MGBW) ? `
                @media (max-width: 1166px) {
                    max-height: unset;
                    margin: 0;
                    order: 1;
                }
            ` : ''}
        `,
    },
    logo: {
        css: css`
            ${isThemeActive(THEME_IDS.MGBW) ? `
                width: auto;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                @media (max-width: 1166px) {
                    position: absolute;
                    left: 45%;
                    transform: translateX(-50%);
                }
            ` : `
                width: 20%;
            `}
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: auto;
                            margin: 0 auto;
                            padding-top: 0px;
                            position: absolute;
                            left: ${isThemeActive(THEME_IDS.MGBW) ? '45%' : '50%'};
                            transform: translateX(-50%);
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            @media (min-width: 992px) and (max-width: 1166px) {
                width: auto !important;
                margin: 0 auto !important;
                padding-top: 0px !important;
            }
        `,
    },
    search: {
        css: css`
            ${isThemeActive(THEME_IDS.MGBW)
                ? `display: none;`
                : isThemeActive(THEME_IDS.GLOBAL_VIEWS) 
                    ? `width: 15%;` 
                    : `
                        flex-grow: 1; 
                        margin-right: 50px;
                    `
            }
            margin-left: auto;

            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    newBrandLogo: {
        css: css`
            margin-left: 90px;
            margin-right:30px;
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    openTrade: {
        css: css`
            padding-bottom: 2px;
            margin-left: 12px;
            ${isThemeActive(THEME_IDS.MGBW) ? `
                padding-bottom: 0;
                margin-left: 0;
            ` : ''}
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    signInAccount: {
        css: css`
            margin-left: ${isThemeActive(THEME_IDS.MGBW) ? '0' : '32px'};
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    myAccount: {
        css: css`
            width: 18%;
            margin-left: 20px;
            ${isThemeActive(THEME_IDS.MGBW) ? `
                width: auto;
                margin-left: 0;
            ` : ''}
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    cart: {
        css: css`
         @media (min-width: 992px) and (max-width: 1166px) {
                display:flex !important;
                justify-content: flex-end ;
            }
            > div {
                display: flex;
                justify-content: flex-end;
            }
        `,
    },
    signIn: {
        css: css`
            @media (min-width: 992px) and (max-width: 1166px) {
                display:flex !important;
                justify-content: flex-end;
            }
            > div {
                display: flex;
                justify-content: flex-end;
            }
        `,
    },
    mobileSearchBarToggle: {
        css: css`
            margin-right: 14px;
            height: 20px;

            ${isThemeActive(THEME_IDS.MGBW) ? `
                margin-right: 0;
                @media (min-width: 1167px) {
                    order: -1;
                    padding-top: 0;
                }
            ` : ''}

            ${!isThemeActive(THEME_IDS.MGBW) ? `
                @media (min-width: 1167px) {
                    display: none;
                }
            ` : ''}
        `,
    },
    mobileSearchButton: {
        size: isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW) ? 20 : 24,
        buttonType: "solid",
        color: "secondary",
        css: css`
            padding: 0;
            border: none;
            background: transparent;
            min-height: 0 !important;
            height: 20px;
            display: flex;
            align-items: center;
            ${isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW) ? '' : 'top: -2px !important; position: relative;'}
            &:hover {
                background: none;
            }
        `,
    },
    mobileSearchButtonIcon: {
        size: isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW) ? 20 : 24,
        css: css`
            position: relative !important;
            top: 0 !important;
        `
    },
};

const styles = headerContainerStyle;

function getSearchIcon(): React.ComponentType {
    switch (getActiveThemeId()) {
        case THEME_IDS.MGBW:
            return MGBWSearchIcon;
        default:
            return Search;
    }
}

export const HeaderContainer: FC<Props> = ({ id, session }) => {
    const { toggleMobileSearch, focusSearchInput } = useMobileSearch();

    const handleMobileSearchClick = () => {
        toggleMobileSearch();
        focusSearchInput();
    };

    return (
        <StyledWrapper {...styles.headerContainer}>
            <StyledWrapper {...styles.headerSection}>
                <StyledWrapper {...(!session.isAuthenticated ? styles.borderBottom : styles.signInborderBottom)}>
                    <StyledWrapper {...styles.logoSearchContainer} id="headerHeightRef">
                        <StyledWrapper {...styles.logo}>
                            <Zone contentId={id} zoneName="Logo" />
                        </StyledWrapper>
                        <Hidden below="lg" {...styles.search}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="Search" />
                            </StyledWrapper>
                        </Hidden>
                        {!session.isAuthenticated && (
                            <Hidden below="lg" {...styles.openTrade}>
                                <StyledWrapper>
                                    <Zone contentId={id} zoneName="OpenTrade" />
                                </StyledWrapper>
                            </Hidden>
                        )}
                        <Hidden below="lg" {...(!session.isAuthenticated ? styles.signInAccount : styles.myAccount)}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="MyAccount" />
                            </StyledWrapper>
                        </Hidden>
                        <StyledWrapper {...styles.mobileSearchBarToggle}>
                            <Button
                                className="mobile-search-button"
                                onClick={handleMobileSearchClick}
                                {...styles.mobileSearchButton}
                            >
                                <ButtonIcon className="mobile-search-button-icon" {...styles.mobileSearchButtonIcon} src={getSearchIcon()} />
                                <VisuallyHidden>Search</VisuallyHidden>
                            </Button>
                        </StyledWrapper>
                        {session.isAuthenticated && (
                            <StyledWrapper {...styles.cart}>
                                <Zone contentId={id} zoneName="Cart" />
                            </StyledWrapper>
                        )}
                        {!session.isAuthenticated && (
                            <Hidden above="md" {...styles.signIn}>
                                <Zone contentId={id} zoneName="SignIn" />
                            </Hidden>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.mainNavigation}>
                    <Zone contentId={id} zoneName="mainNavigation" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderContainer),
    definition: {
        group: "Basic",
        displayName: "Header Container",
    },
};

export default widgetModule;
